export default __webpack_public_path__ + "static/media/webinvictusmobile.75218750.webp";